/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSIdlePhase.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */ 
namespace WinAnimation.Phase {
    import WinLine = WinAnimation.Line.BSWinLine;
    import GameResult = DTO.GameResult;
    import Win = DTO.Win;
    /**
    * BSIdlePhase is inherited class of IdlePhase.
    * @author <a href=mailto:SNethani@Gauselmann.com>Sujata Nethani</a>
    * $Date: 3 July 2020 $     
    */
    export class BSIdlePhase extends IdlePhase {
        protected linesToAnimate: WinLine[];
        protected getNonWinTag: WinAnimation.Line.BSWinLine[];
        protected getWinTag: WinAnimation.Line.BSWinLine[];
        
        protected collectLinesToAnimate(gameResult: GameResult): void {
            this.getNonWinTag = [];
            this.getWinTag = [];
            for (let i = 0, win; win = gameResult.wins[i]; i++) {
                let winLine: WinLine = this.winAnimation.getLineWithId(win.lineId);
                this.linesToAnimate.push(winLine);
            }            
            this.getNonWinTagPos();
        }

        protected unlightAllLines(): void {
            for (let i = 0, winLine: WinAnimation.Line.BSWinLine; winLine = this.winAnimation.winLines[i]; i++) {
                winLine.unlight(this.winAnimation.reelContainer.darkeningColor, this.winAnimation.reelContainer.darkeningAmount);
                (winLine.leftTag as WinAnimation.Line.BSTag).selectLine();
                (winLine.rightTag as WinAnimation.Line.BSTag).selectLine();
            }
            this.highLightNonWinTags();
        }

        private highLightNonWinTags() {  
            for (let item of this.getNonWinTag) {
                (item.leftTag as WinAnimation.Line.BSTag).select();
                (item.rightTag as WinAnimation.Line.BSTag).select();
            }
        }

        private getNonWinTagPos(): void {
            for (let i = 0, winLine: WinAnimation.Line.BSWinLine; winLine = this.winAnimation.winLines[i]; i++) {
                if (this.linesToAnimate.indexOf(winLine) != -1) {
                    this.getWinTag.push(winLine)
                } else {
                    this.getNonWinTag.push(winLine);
                }
            }
        }

        reset() {
            this.getNonWinTag = [];
            this.getWinTag = [];
            super.reset();
        }
        
        showLineWinBelow(win:Win,duration?:number):void{
            let prefix:string = "";
            if(win.lineId===0){
                prefix="SCATTER: ";
            }
            if(win.lineId>0){
                let line:string = this.phaserGame.portalAPI.resourceProvider.getString("LINE")+" ";
                prefix=line+win.lineId+": ";
            }
            this.linesToAnimate[0].winAmountBox.setWinAmount(win.winSum,prefix,null,0);
        }
    }
}
